import React from 'react';
import _ from 'lodash';
import { ShiftSlotStatus } from 'utilities/enum-utils';
import { Popover } from '@blueprintjs/core';
import { ActionMenu, ActionMenuItem } from 'common-components/action-menu';
import { ActionIcon, Button, Group } from '@good/ui/core';
import { ChevronDown } from '@good/icons';

interface IAssignSessionButtonProps {
  selectedWorker: unknown;
  isBookingCancelled: boolean;
  onAssignWorker: (shiftSlotStatus: ShiftSlotStatus) => void;
}

export const AssignSessionButton: React.FunctionComponent<IAssignSessionButtonProps> = ({
  selectedWorker,
  isBookingCancelled,
  onAssignWorker,
}) => {
  return (
    <Group gap={4}>
      <Button
        disabled={!selectedWorker}
        onClick={() => onAssignWorker(ShiftSlotStatus.CONFIRMED)}
        size='large'
        className='ml-large'
      >
        Assign as Confirmed
      </Button>

      {!isBookingCancelled && (
        <Popover
          content={
            <ActionMenu>
              <ActionMenuItem text='Assign as pending' onClick={() => onAssignWorker(ShiftSlotStatus.PENDING)} />
            </ActionMenu>
          }
          position='bottom-left'
          usePortal={false}
          disabled={!selectedWorker}
        >
          <ActionIcon disabled={!selectedWorker} size='input-sm' variant='default'>
            <ChevronDown />
          </ActionIcon>
        </Popover>
      )}
    </Group>
  );
};
